export const masks = {
  CELLPHONE_MASK: [
    '(',
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/
  ],
  CNPJ_MASK: [
    /[0-9A-Z]/,
    /[0-9A-Z]/,
    '.',
    /[0-9A-Z]/,
    /[0-9A-Z]/,
    /[0-9A-Z]/,
    '.',
    /[0-9A-Z]/,
    /[0-9A-Z]/,
    /[0-9A-Z]/,
    '/',
    /[0-9A-Z]/,
    /[0-9A-Z]/,
    /[0-9A-Z]/,
    /[0-9A-Z]/,
    '-',
    /\d/,
    /\d/
  ],
  CPF_MASK: [
    /\d/,
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/
  ],
  CPF_ONLY_MASK: [
    /\d/,
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '.',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/
  ],
  DATE_MASK: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
  DATETIME_MASK: [
    /\d/,
    /\d/,
    '/',
    /\d/,
    /\d/,
    '/',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    ':',
    /\d/,
    /\d/
  ],
  PHONE_MASK: [
    '(',
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/
  ],
  TIME_MASK: [/\d/, /\d/, ':', /\d/, /\d/],
  USERNAME_MASK: Array.from({ length: 100 }).map(() => /[a-z0-9._@]/),
  ZIPCODE_MASK: [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
  CPF_ONLY_PT: [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/],
  CELLPHONE_MASK_PT: [
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/
  ],
  // Uruguay: CI format X.XXX.XXX-X (7-8 digits)
  CI_MASK_UY: [/\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/],
  // Paraguay: CI format X.XXX.XXX (6-8 digits, no check digit)
  CI_MASK_PY: [/\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/],
  // Uruguay phone: 09X XXX XXX (9 digits)
  CELLPHONE_MASK_UY: [
    '0',
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/
  ],
  // Paraguay phone: 09XX XXX XXX (10 digits)
  CELLPHONE_MASK_PY: [
    '0',
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/
  ],
  // Spain: DNI/NIE format XXXXXXXX-X (8 digits + letter) or X-XXXXXXX-X (NIE)
  DNI_MASK_ES: [
    /[0-9xXyYzZ]/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /[a-zA-Z]/
  ],
  // Spain phone: 6XX XXX XXX or 7XX XXX XXX (9 digits)
  CELLPHONE_MASK_ES: [
    /[67]/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/,
    ' ',
    /\d/,
    /\d/,
    /\d/
  ]
}
